import "App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "layout";
import ModalManager from "modal";
import { useCallback, useEffect, useState } from "react";
import { api, ui } from "services";
import { useConnectedWallet } from "@terra-money/wallet-provider";
import { depositMAG, depositMSTR } from "services/terra";
import { useDispatch, useSelector } from "react-redux";
import { RootState, store } from "reducer/store";
import {
  AuthInterface,
  Chain,
  ContractType,
  CustomerInterface,
  LoginType,
} from "interfaces";
import axios from "axios";
import { bulkSetUserInfo } from "reducer/user.slice";
import { SingletonLCD } from "services/lcd";
import { getContract } from "services/contract";
function App() {
  const user = useSelector((state: RootState) => state.user);
  const wallets = useSelector((state: RootState) => state.wallets);
  const loginType = useSelector((state: RootState) => state.logintype);
  const dispatch = useDispatch();
  const connectedWallet = useConnectedWallet();
  const lcd = SingletonLCD.getInstance();
  const [isLoading, setIsLoading] = useState(true);
  const [trigger, setTrigger] = useState(false);

  const depositMSTRListener = useCallback(
    async (e: CustomEvent) => {
      if (!connectedWallet) {
        return;
      }
      const authWallet =
        store.getState().wallets[LoginType.Terra]?.[AuthInterface.identity];
      const amount = e.detail.amount;
      const denom = e.detail.denom;
      await new Promise((resolve, reject) => {
        resolve(null);
      });
      if (connectedWallet.walletAddress !== authWallet) {
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMSTR.${e.detail.eventId}`, {
            detail: { error: "terra_wallet_not_match" },
          })
        );
        return;
      }
      try {
        const data = await axios.get("https://fcd.terra.dev/v1/txs/gas_prices");
        const result = await depositMSTR(
          lcd,
          connectedWallet,
          amount,
          e.detail.eventId,
          { denom, price: data.data[denom] }
        );
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMSTR.${e.detail.eventId}`, {
            detail: result,
          })
        );
      } catch (err) {
        console.log({ err });
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMSTR.${e.detail.eventId}`, {
            detail: { error: err.toString() },
          })
        );
      }
    },
    [connectedWallet]
  );

  const depositMAGListener = useCallback(
    async (e: CustomEvent) => {
      if (!connectedWallet) {
        return;
      }
      const authWallet =
        store.getState().wallets[LoginType.Terra]?.[AuthInterface.identity];
      const amount = e.detail.amount;
      const denom = e.detail.denom;
      await new Promise((resolve, reject) => {
        resolve(null);
      });
      if (connectedWallet.walletAddress !== authWallet) {
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMAG.${e.detail.eventId}`, {
            detail: { error: "terra_wallet_not_match" },
          })
        );
        return;
      }
      try {
        const data = await axios.get("https://fcd.terra.dev/v1/txs/gas_prices");
        const result = await depositMAG(
          lcd,
          connectedWallet,
          amount,
          e.detail.eventId,
          { denom, price: data.data[denom] }
        );
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMAG.${e.detail.eventId}`, {
            detail: result,
          })
        );
      } catch (err) {
        console.log({ err });
        document.dispatchEvent(
          new CustomEvent(`depositedTerraMAG.${e.detail.eventId}`, {
            detail: { error: err.toString() },
          })
        );
      }
    },
    [connectedWallet]
  );

  const getBalanceMSTRListener = useCallback(
    async (e: CustomEvent) => {
      await new Promise((resolve, reject) => {
        resolve(null);
      });
      try {
        const result = await lcd.wasm.contractQuery(
          getContract(ContractType.MSTR, Chain.Terra),
          {
            balance: {
              address:
                wallets[LoginType.Terra]?.[AuthInterface.identity] ??
                connectedWallet.terraAddress,
            },
          }
        );
        document.dispatchEvent(
          new CustomEvent(`getBalanceTerraMSTR.${e.detail.eventId}`, {
            detail: result,
          })
        );
      } catch (err) {
        console.log({ err });
        document.dispatchEvent(
          new CustomEvent(`getBalanceTerraMSTR.${e.detail.eventId}`, {
            detail: { balance: 0 },
          })
        );
      }
    },
    [connectedWallet]
  );

  const getBalanceMAGListener = useCallback(
    async (e: CustomEvent) => {
      await new Promise((resolve, reject) => {
        resolve(null);
      });
      try {
        const result = await lcd.wasm.contractQuery(
          getContract(ContractType.MAG, Chain.Terra),
          {
            balance: {
              address:
                wallets[LoginType.Terra]?.[AuthInterface.identity] ??
                connectedWallet.terraAddress,
            },
          }
        );
        document.dispatchEvent(
          new CustomEvent(`getBalanceTerraMAG.${e.detail.eventId}`, {
            detail: result,
          })
        );
      } catch (err) {
        document.dispatchEvent(
          new CustomEvent(`getBalanceTerraMAG.${e.detail.eventId}`, {
            detail: { balance: 0 },
          })
        );
      }
    },
    [connectedWallet]
  );

  async function loadUserInfo() {
    let token = sessionStorage.getItem("token");
    if (!token) {
      return;
    }
    let rs = await api.post("/dao/get-customer-info", {});
    dispatch(bulkSetUserInfo({ ...rs }));
    // console.log("load user info")
    // await api.getTokenBalance();
  }
  const userInfo: any = useSelector((state: RootState) => state.user);
  async function registerBNBEvent() {
    try {
      let type = localStorage.getItem("user_from_src");
      await api.post("/bnbevent/register-bnb-event", { type });
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!userInfo?.A || !sessionStorage.getItem("token")) {
      return;
    }
    registerBNBEvent();
  }, [userInfo?.A]);

  useEffect(() => {
    if (window.location.href) {
      let query = new URLSearchParams(window.location.href.split("?")[1]);
      let src = query.get("src");
      if (src) {
        localStorage.setItem("user_from_src", src);
        if (userInfo?.A) {
          registerBNBEvent();
        }
      }
    }
  }, []);

  useEffect(() => {
    console.log("load by change login type")
    api.getTokenBalance();
  }, [loginType]);

  useEffect(() => {
    api
      .getSSOMeta()
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setTimeout(() => {
          setTrigger(!trigger);
        }, 2000);
      });
  }, [trigger]);

  useEffect(() => {
    window.document.addEventListener(
      "depositTerraMSTR",
      depositMSTRListener as unknown as EventListener
    );
    window.document.addEventListener(
      "depositTerraMAG",
      depositMAGListener as unknown as EventListener
    );
    window.document.addEventListener(
      "getBalanceTerraMSTR",
      getBalanceMSTRListener as unknown as EventListener
    );
    window.document.addEventListener(
      "getBalanceTerraMAG",
      getBalanceMAGListener as unknown as EventListener
    );
    return () => {
      window.document.removeEventListener(
        "depositTerraMSTR",
        depositMSTRListener as unknown as EventListener
      );
      window.document.removeEventListener(
        "depositTerraMAG",
        depositMAGListener as unknown as EventListener
      );
      window.document.removeEventListener(
        "getBalanceTerraMSTR",
        getBalanceMSTRListener as unknown as EventListener
      );
      window.document.removeEventListener(
        "getBalanceTerraMAG",
        getBalanceMAGListener as unknown as EventListener
      );
    };
  }, [connectedWallet]);

  useEffect(() => {
    window.addEventListener("focus", loadUserInfo);
    return () => {
      window.removeEventListener("focus", loadUserInfo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.[CustomerInterface.id]]);
  useEffect(() => {
    if (!isLoading) {
      ui.showPopup(
        "Notice",
        "Monsterra has stopped accepting new asset deposits. Users can still withdraw their assets from the game until the end of September 2026. After that, the game will be removed from the website and app stores."
      );
    }
  }, [isLoading]);

  if (isLoading) return <></>;

  return (
    <div className="App">
      <Router basename="/">
        <ModalManager />
        <Routes>
          <Route path="/*" element={<Layout />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
